<template>
  <div class="page-template" v-loading="loading">
    <!--    <search-form-template-->
    <!--      ref="querySearchForm"-->
    <!--      class="query-search-form"-->
    <!--      :searchOptions="searchOptions"-->
    <!--      @searchSubmit="searchSubmit"-->
    <!--      @clear="clearSearch"-->
    <!--      @clearSelect="clearSelect"-->
    <!--      :toolConfig="toolConfig"-->
    <!--      @btnCommon="exportExcel"-->
    <!--    ></search-form-template>-->
    <el-tabs v-model="activeTab">
      <el-tab-pane label="库存商品汇总" name="goodsSum">
        <search-form-template
          ref="querySearchForm"
          class="query-search-form"
          :searchOptions="searchOptions"
          @searchSubmit="searchSubmit"
          @clear="clearSearch"
          :toolConfig="toolConfig"
          @btnCommon="exportExcel"
        ></search-form-template>
        <table-template v-if="activeTab === 'goodsSum'" ref="goodsSum" :tableOptions="goodsSum"></table-template>
      </el-tab-pane>
      <el-tab-pane label="库存类别汇总" name="categorySum">
        <search-form-template
          ref="querySearchForm"
          class="query-search-form"
          :searchOptions="searchOptions2"
          @searchSubmit="searchSubmit"
          @clear="clearSearch"
          :toolConfig="toolConfig"
          @btnCommon="exportExcel"
        ></search-form-template>
        <table-template v-if="activeTab === 'categorySum'" ref="categorySum"
                        :tableOptions="categorySum"></table-template>
      </el-tab-pane>
      <el-tab-pane label="库存品牌汇总" name="brandSum">
        <search-form-template
          ref="querySearchForm"
          class="query-search-form"
          :searchOptions="searchOptions3"
          @searchSubmit="searchSubmit"
          @clear="clearSearch"
          :toolConfig="toolConfig"
          @btnCommon="exportExcel"
        ></search-form-template>
        <table-template v-if="activeTab === 'brandSum'" ref="brandSum" :tableOptions="brandSum"></table-template>
      </el-tab-pane>
      <el-tab-pane label="库存供应商汇总" name="suppleSum">
        <search-form-template
          ref="querySearchForm"
          class="query-search-form"
          :searchOptions="searchOptions4"
          @searchSubmit="searchSubmit"
          @clear="clearSearch"
          :toolConfig="toolConfig"
          @btnCommon="exportExcel"
        ></search-form-template>
        <table-template v-if="activeTab === 'suppleSum'" ref="suppleSum" :tableOptions="suppleSum"></table-template>
      </el-tab-pane>
      <el-tab-pane label="库存告警" name="waringSum">
        <search-form-template
          ref="querySearchForm"
          class="query-search-form"
          :searchOptions="searchOptions"
          @searchSubmit="searchSubmit"
          @clear="clearSearch"
          :toolConfig="toolConfig"
          @btnCommon="exportExcel"
        ></search-form-template>
        <table-template v-if="activeTab === 'waringSum'" ref="waringSum" :tableOptions="waringSum"></table-template>
      </el-tab-pane>
      <el-tab-pane label="负库存商品" name="minusSum">
        <search-form-template
          ref="querySearchForm"
          class="query-search-form"
          :searchOptions="searchOptions"
          @searchSubmit="searchSubmit"
          @clear="clearSearch"
          :toolConfig="toolConfig"
          @btnCommon="exportExcel"
        ></search-form-template>
        <table-template v-if="activeTab === 'minusSum'" ref="minusSum" :tableOptions="minusSum"></table-template>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import searchFormTemplate from '@/components/template/searchFormTemplate';
import tableTemplate from '@/components/template/tableTemplate';
import api from '@/config/api';
import userPower from '@/mixin/userPower'

export default {
  mixins: [userPower],
  name: 'RoleManager',
  components: {
    tableTemplate,
    searchFormTemplate,
  },
  data() {
    return {
      activeTab: 'goodsSum',
      loading: false,
      treeConfig: {
        id: 'menuTree',
        showCheckbox: true,
        data: [],
        nodeKey: 'id',
        defaultProps: {
          children: 'children',
          label: 'name'
        },
        request: {
          api: api.system.rolePrivilege,
          param: {roleId: ''}
        }
      },
      // 高级搜索条件
      searchOptions: {
        simple: [{label: '商品名称', prop: 'otherName', type: 'input', isFuzzy: true, placeholder: '请输入条码/名称/自编码'}],
        complex: [
          {
            label: '门店名称',
            type: 'select',
            prop: 'storeId',
            span: 8,
            data: [],
            isHasAll: true,
            url: api.store.store,
            searchName: 'searchOptions',
            change: this.storeChange,
          },
          {
            label: "仓库",
            type: "select",
            prop: "warehouseId",
            // url: api.warehouse.warehouse,
            // param: {relateType: this.$utils.getSysUser().type},
            data: [],
            span: 8,
          },
          {
            label: '供应商',
            type: 'select',
            prop: 'supplierId',
            data: [],
            span: 8,
            // url: api.archives.supplier,
          },
          {
            label: '品牌',
            type: 'select',
            prop: 'goodsBrandId',
            data: [],
            span: 8,
            // url: api.archives.brand,
          },
          {
            label: "类别",
            type: 'cascaderMultiple',
            prop: 'goodsCategoryIds',
            data: [],
            span: 8,
            valueKey: 'value',
            change: this.typeChange,
            url: api.archives.getCategoryTree,
          },
          {label: '成本价', prop: 'PurchasePrice', type: 'numberRange', precision: 2, span: 8, inputWidth: '90px'},
        ]
      },
      searchOptions2: {
        simple: [{label: '', prop: 'categoryNameCode', type: 'input', isFuzzy: true, placeholder: '请输入类别编码/名称'}],
        complex: [
          {
            label: '门店名称',
            type: 'select',
            prop: 'storeId',
            span: 8,
            data: [],
            isHasAll: true,
            url: api.store.store,
            searchName: 'searchOptions2',
            change: this.storeChange,
          },
          {
            label: "仓库",
            type: "select",
            prop: "warehouseId",
            // url: api.warehouse.warehouse,
            // param: {relateType: this.$utils.getSysUser().type},
            data: [],
            span: 8,
          },
          {
            label: "类别",
            type: 'cascaderMultiple',
            prop: 'goodsCategoryIds',
            data: [],
            span: 8,
            valueKey: 'value',
            change: this.typeChange,
            url: api.archives.getCategoryTree,
          },
        ]
      },
      searchOptions3: {
        simple: [{label: '', prop: 'brandNameCode', type: 'input', isFuzzy: true, placeholder: '请输入品牌编码/名称'}],
        complex: [
          {
            label: '门店名称',
            type: 'select',
            prop: 'storeId',
            span: 8,
            data: [],
            isHasAll: true,
            url: api.store.store,
            searchName: 'searchOptions3',
            change: this.storeChange,
          },
          {
            label: "仓库",
            type: "select",
            prop: "warehouseId",
            // url: api.warehouse.warehouse,
            // param: {relateType: this.$utils.getSysUser().type},
            data: [],
            span: 8,
          },
          {
            label: '品牌',
            type: 'select',
            prop: 'goodsBrandId',
            data: [],
            span: 8,
            // url: api.archives.brand,
          },
        ]
      },
      searchOptions4: {
        simple: [{label: '', prop: 'supplierNameCode', type: 'input', isFuzzy: true, placeholder: '请输入供应商编码/名称'}],
        complex: [
          {
            label: '门店名称',
            type: 'select',
            prop: 'storeId',
            span: 8,
            data: [],
            isHasAll: true,
            url: api.store.store,
            searchName: 'searchOptions4',
            change: this.storeChange,
          },
          {
            label: "仓库",
            type: "select",
            prop: "warehouseId",
            // url: api.warehouse.warehouse,
            // param: {relateType: this.$utils.getSysUser().type},
            data: [],
            span: 8,
          },
          {
            label: '供应商',
            type: 'select',
            prop: 'supplierId',
            data: [],
            span: 8,
            // url: api.archives.supplier,
          },
        ]
      },
      // 更多功能
      toolConfig: [
        {
          label: '打印',
          code: 'print',
        },
        {
          label: '导出',
          code: 'export',
          callback: this.exportExcel
        }
      ],
      // 库存商品汇总
      goodsSum: {
        tableName: 'goodsSum',
        indexShow: true,//是否显示索引
        showSummary: true,
        clearSortable: true,
        summaryColumns: ['inventoryNum', 'purchaseMoney', 'retailMoney'],
        param: {sumType: 10},
        columns: [
          {
            label: '仓库名称',
            prop: 'warehouseName',
            width: '190',
            align: 'center',
            sortable: 'custom'
          },
          {
            label: '条码',
            prop: 'barCode',
            width: '150',
            align: 'center',
            sortable: 'custom'
          },
          // {
          //   label: '自编码',
          //   prop: 'artNo',
          //   width: '150',
          //   align: 'center'
          // },
          {
            label: '商品名称',
            prop: 'goodsName',
            width: '150',
            align: 'center',
            sortable: 'custom'
          },
          {
            label: '规格',
            prop: 'specs',
            width: '70',
            align: 'center'
          },
          {
            label: '单位',
            prop: 'unitName',
            width: '70',
            align: 'center'
          },
          {
            label: '库存数量',
            prop: 'inventoryNum',
            width: '120',
            align: 'center',
            sortable: 'custom'
          },
          {
            label: '成本价',
            prop: 'purchasePrice',
            width: '120',
            align: 'center',
            sortable: 'custom'
          },
          {
            label: '成本金额',
            prop: 'purchaseMoney',
            width: '120',
            align: 'center',
            sortable: 'custom'
            //deal:this.purchasePriceSum
          },
          {
            label: '档案零售价',
            prop: 'retailPrice',
            width: '120',
            align: 'center',
            sortable: 'custom'
          },
          {
            label: '零售金额',
            prop: 'retailMoney',
            width: '120',
            align: 'center',
            sortable: 'custom'
            //deal:this.retailPriceSum
          },
          // {
          //   label: '箱数',
          //   prop: 'boxNum',
          //   width: '80',
          //   align: 'center'
          // },
          {
            label: '商品类别',
            prop: 'goodsCategoryName',
            width: '120',
            align: 'center',
            sortable: 'custom'
          },
          {
            label: '品牌',
            prop: 'goodsBrandName',
            width: '120',
            align: 'center',
            sortable: 'custom'
          },
          {
            label: '供应商',
            prop: 'supplierName',
            width: '120',
            align: 'center',
            sortable: 'custom'
          },

        ],
        url: api.warehouse.inventorySum
      },
      // 类别汇总
      categorySum: {
        clearSortable: true,
        indexShow: true,//是否显示索引
        param: {sumType: 20},
        showSummary: true,
        summaryColumns: ['inventoryNum', 'purchaseMoney', 'retailMoney'],
        // param: {sumType: 20, warehouseId: this.$utils.getSysUser().warehouseId},
        columns: [
          {
            label: '仓库名称',
            prop: 'warehouseName',
            width: '190',
            align: 'center',
            sortable: 'custom'
          },
          {
            label: '类别编码',
            prop: 'goodsCategoryCode',
            width: '120',
            align: 'center',
            sortable: 'custom'
          },
          {
            label: '类别名称',
            prop: 'goodsCategoryName',
            width: '150',
            align: 'center',
            sortable: 'custom'
          },
          {
            label: '库存数量',
            prop: 'inventoryNum',
            width: '150',
            align: 'center',
            sortable: 'custom'
          },
          {
            label: '成本金额',
            prop: 'purchaseMoney',
            width: '150',
            align: 'center',
            sortable: 'custom'
          },
          {
            label: '零售金额',
            prop: 'retailMoney',
            width: '150',
            align: 'center',
            sortable: 'custom'
          },
        ],
        url: api.warehouse.inventorySum
      },
      // 品牌汇总
      brandSum: {
        clearSortable: true,
        indexShow: true,//是否显示索引
        param: {sumType: 30},
        showSummary: true,
        summaryColumns: ['inventoryNum', 'purchaseMoney', 'retailMoney'],
        // param: {sumType: 30, warehouseId: this.$utils.getSysUser().warehouseId},
        columns: [
          {
            label: '仓库名称',
            prop: 'warehouseName',
            width: '190',
            align: 'center',
            sortable: 'custom'
          },
          {
            label: '品牌编码',
            prop: 'brandCode',
            width: '120',
            align: 'center',
            sortable: 'custom'
          },
          {
            label: '品牌名称',
            prop: 'goodsBrandName',
            width: '150',
            align: 'center',
            sortable: 'custom'
          },
          {
            label: '库存数量',
            prop: 'inventoryNum',
            width: '150',
            align: 'center',
            sortable: 'custom'
          },
          {
            label: '成本金额',
            prop: 'purchaseMoney',
            width: '150',
            align: 'center',
            sortable: 'custom'
          },
          {
            label: '零售金额',
            prop: 'retailMoney',
            width: '150',
            align: 'center',
            sortable: 'custom'
          },
        ],
        url: api.warehouse.inventorySum
      },
      // 告警
      waringSum: {
        clearSortable: true,
        indexShow: true,//是否显示索引
        param: {sumType: 50},
        // param: {sumType: 50, warehouseId: this.$utils.getSysUser().warehouseId},
        columns: [
          {
            label: '仓库名称',
            prop: 'warehouseName',
            width: '190',
            align: 'center',
            sortable: 'custom'
          },
          {
            label: '条码',
            prop: 'barCode',
            width: '120',
            align: 'center',
            sortable: 'custom'
          },
          {
            label: '商品名称',
            prop: 'goodsName',
            width: '150',
            align: 'center',
            sortable: 'custom'
          },
          // {
          //   label: '自编码',
          //   prop: 'artNo',
          //   width: '150',
          //   align: 'center'
          // },
          {
            label: '规格',
            prop: 'specs',
            width: '70',
            align: 'center'
          },
          {
            label: '单位',
            prop: 'unitName',
            width: '70',
            align: 'center'
          },
          {
            label: '当前库存',
            prop: 'inventoryNum',
            width: '150',
            align: 'center',
            sortable: 'custom'
          },
          {
            label: '库存下限',
            prop: 'lowInventory',
            width: '150',
            align: 'center',
            sortable: 'custom'
          },
          {
            label: '库存上限',
            prop: 'highInventory',
            width: '150',
            align: 'center',
            sortable: 'custom'
          },
          {
            label: '类别',
            prop: 'goodsCategoryName',
            width: '150',
            align: 'center',
            sortable: 'custom'
          },
          {
            label: '品牌',
            prop: 'goodsBrandName',
            width: '150',
            align: 'center',
            sortable: 'custom'
          },
          {
            label: "供应商",
            prop: "supplierName",
            width: "150",
            align: "center",
            sortable: 'custom'
          },
          // {
          //   label: '补充数量',
          //   prop: 'goodsNum',
          //   width: '150',
          //   align: 'center'
          // },
        ],
        url: api.warehouse.inventorySum
      },
      // 负库存
      minusSum: {
        clearSortable: true,
        indexShow: true,//是否显示索引
        param: {sumType: 60},
        // param: {sumType: 60, warehouseId: this.$utils.getSysUser().warehouseId},
        columns: [
          {
            label: '仓库名称',
            prop: 'warehouseName',
            width: '190',
            align: 'center',
            sortable: 'custom'
          },
          {
            label: '条码',
            prop: 'barCode',
            width: '120',
            align: 'center',
            sortable: 'custom'
          },
          {
            label: '商品名称',
            prop: 'goodsName',
            width: '150',
            align: 'center',
            sortable: 'custom'
          },
          // {
          //   label: '自编码',
          //   prop: 'artNo',
          //   width: '150',
          //   align: 'center'
          // },
          {
            label: '规格',
            prop: 'specs',
            width: '70',
            align: 'center'
          },
          {
            label: '单位',
            prop: 'unitName',
            width: '70',
            align: 'center'
          },
          {
            label: '库存数量',
            prop: 'inventoryNum',
            width: '150',
            align: 'center',
            sortable: 'custom'
          },
          {
            label: '类别',
            prop: 'goodsCategoryName',
            width: '150',
            align: 'center',
            sortable: 'custom'
          },
          {
            label: '品牌',
            prop: 'goodsBrandName',
            width: '150',
            align: 'center',
            sortable: 'custom'
          },
          {
            label: "供应商",
            prop: "supplierName",
            width: "150",
            align: "center",
            sortable: 'custom'
          },
        ],
        url: api.warehouse.inventorySum
      },
      // 供应商
      suppleSum: {
        clearSortable: true,
        indexShow: true,//是否显示索引
        param: {sumType: 40},
        showSummary: true,
        summaryColumns: ['inventoryNum', 'purchaseMoney', 'retailMoney'],
        // param: {sumType: 40, warehouseId: this.$utils.getSysUser().warehouseId},
        columns: [
          {
            label: '仓库名称',
            prop: 'warehouseName',
            width: '190',
            align: 'center',
            sortable: 'custom'
          },
          {
            label: '供应商编码',
            prop: 'supplierCode',
            width: '120',
            align: 'center',
            sortable: 'custom'
          },
          {
            label: '供应商',
            prop: 'supplierName',
            width: '150',
            align: 'center',
            sortable: 'custom'
          },
          {
            label: '库存数量',
            prop: 'inventoryNum',
            width: '150',
            align: 'center',
            sortable: 'custom'
          },
          {
            label: '成本金额',
            prop: 'purchaseMoney',
            width: '150',
            align: 'center',
            sortable: 'custom'
          },
          {
            label: '零售金额',
            prop: 'retailMoney',
            width: '150',
            align: 'center',
            sortable: 'custom'
          },
        ],
        url: api.warehouse.inventorySum
      }

    };
  },
  created() {
    this.title = document.title;
    this.setStore(this.searchOptions.complex);
    this.setStore(this.searchOptions2.complex);
    this.setStore(this.searchOptions3.complex);
    this.setStore(this.searchOptions4.complex);
    if (this.$utils.getSysUser().storeId) {//门店身份
      this.searchOptions.complex.filter(v => v.prop === 'warehouseId')[0].url = api.warehouse.warehouse
      this.searchOptions2.complex.filter(v => v.prop === 'warehouseId')[0].url = api.warehouse.warehouse
      this.searchOptions3.complex.filter(v => v.prop === 'warehouseId')[0].url = api.warehouse.warehouse
      this.searchOptions4.complex.filter(v => v.prop === 'warehouseId')[0].url = api.warehouse.warehouse
      this.searchOptions.complex.filter(item => item.prop === 'goodsBrandId')[0].url = api.archives.brand
      this.searchOptions3.complex.filter(item => item.prop === 'goodsBrandId')[0].url = api.archives.brand
      this.searchOptions.complex.filter(item => item.prop === 'supplierId')[0].url = api.archives.supplier
      this.searchOptions4.complex.filter(item => item.prop === 'supplierId')[0].url = api.archives.supplier
    }
  },
  mounted() {
    let storeId = this.$utils.getSysUser().storeId
    if (Object.keys(this.$route.params).length > 0) {
      if (this.$route.params.businessType == '10' || this.$route.params.code == '4') {
        this.activeTab = 'waringSum'
        this.waringSum.param.storeId = storeId ? storeId : -1
        setTimeout(() => {
          this.$refs['waringSum'].operationSuccess();
        }, 300)
      }
      if (this.$route.params.businessType == '70') {
        this.activeTab = 'goodsSum'
        if (this.$route.params.customQuery) {
          let str = this.$route.params.customQuery
          this.goodsSum.param = eval('(' + str + ')')
          this.goodsSum.param.sumType = 10
          this.goodsSum.param.storeId = storeId ? storeId : -1
        }
        setTimeout(() => {
          this.$refs['goodsSum'].operationSuccess();
        }, 300)
      }
    }
  },
  methods: {
    // 选择门店
    storeChange(row, column) {
      row.warehouseId = ''
      row.supplierId = ''
      row.goodsBrandId = ''
      this.$refs[this.activeTab].searchParam = {}
      let warehouseId = []
      let supplierId = []
      let goodsBrandId = []
      if (column.searchName === 'searchOptions2') {
        warehouseId = this.searchOptions2.complex.filter(v => v.prop === 'warehouseId')[0]
      } else if (column.searchName === 'searchOptions3') {
        warehouseId = this.searchOptions3.complex.filter(v => v.prop === 'warehouseId')[0]
        goodsBrandId = this.searchOptions3.complex.filter(item => item.prop === 'goodsBrandId')[0]
      } else if (column.searchName === 'searchOptions4') {
        warehouseId = this.searchOptions4.complex.filter(v => v.prop === 'warehouseId')[0]
        supplierId = this.searchOptions4.complex.filter(item => item.prop === 'supplierId')[0]
      } else {
        warehouseId = this.searchOptions.complex.filter(v => v.prop === 'warehouseId')[0]
        supplierId = this.searchOptions.complex.filter(item => item.prop === 'supplierId')[0]
        goodsBrandId = this.searchOptions.complex.filter(item => item.prop === 'goodsBrandId')[0]
      }
      // 仓库数据
      this.$axios.fetchPost(api.warehouse.warehouse + '/query/warehouse/list', {storeId: row.storeId}).then(res => {
        if (res.code === 200 && res.data) {
          warehouseId.data = res.data
        }
      })
      //通过门店id获取供应商以及仓库
      this.$axios.fetchPost(api.archives.supplier + '/query/supplier/list', {storeId: row.storeId}).then(data => {
        if (data.code === 200) {
          supplierId.data = data.data;
        }
      });
      // 品牌数据
      this.$axios.fetchPost(api.archives.brand + '/query/brand/list', {storeId: row.storeId}).then(data => {
        if (data.code === 200) {
          goodsBrandId.data = data.data;
        }
      });
    },
    // 零售金额
    retailPriceSum(row) {
      return `<span>${(row.inventoryNum * row.retailPrice).toFixed(2)}</span>`;
    },
    // 成本金额
    purchasePriceSum(row) {
      return `<span>${(row.inventoryNum * row.purchasePrice).toFixed(2)}</span>`;
    },
    // 提交查询
    searchSubmit(param) {
      this.$refs[this.activeTab].searchParam = param;
      this.$refs[this.activeTab].operationSuccess();
    },
    // 重置
    clearSearch() {
      this.$refs[this.activeTab].clearSearch();
      if (!this.$utils.getSysUser().storeId) {
        if (this.activeTab === 'categorySum') {
          this.searchOptions2.complex.filter(v => v.prop === 'warehouseId')[0].data = []
        } else if (this.activeTab === 'brandSum') {
          this.searchOptions3.complex.filter(v => v.prop === 'warehouseId')[0].data = []
          this.searchOptions3.complex.filter(item => item.prop === 'goodsBrandId')[0].data = []
        } else if (this.activeTab === 'suppleSum') {
          this.searchOptions4.complex.filter(v => v.prop === 'warehouseId')[0].data = []
          this.searchOptions4.complex.filter(item => item.prop === 'supplierId')[0].data = []
        } else {
          this.searchOptions.complex.filter(v => v.prop === 'warehouseId')[0].data = []
          this.searchOptions.complex.filter(item => item.prop === 'supplierId')[0].data = []
          this.searchOptions.complex.filter(item => item.prop === 'goodsBrandId')[0].data = []
        }
      }
    },
    clearSelect() {
      if (!this.$utils.getSysUser().storeId) {
        let warehouseId = this.searchOptions.complex.filter(v => v.prop === 'warehouseId')[0]
        let supplierId = this.searchOptions.complex.filter(item => item.prop === 'supplierId')[0]
        let goodsBrandId = this.searchOptions.complex.filter(item => item.prop === 'goodsBrandId')[0]
        warehouseId.data = []
        supplierId.data = []
        goodsBrandId.data = []
      }
    },
    exportExcel() {
      let fileName, param;
      let url = api.warehouse.queryinventoryGoodsExport;
      switch (this.activeTab) {
        case 'goodsSum':
          param = this.$refs["goodsSum"].searchParam;
          param.sumType = 10;
          fileName = '库存商品汇总_';
          break;
        case 'categorySum':
          param = this.$refs["categorySum"].searchParam;
          param.sumType = 20;
          fileName = '库存类别汇总_';
          break;
        case 'brandSum':
          param = this.$refs["brandSum"].searchParam;
          param.sumType = 30;
          fileName = '库存品牌汇总_';
          break;
        case 'suppleSum':
          param = this.$refs["suppleSum"].searchParam;
          param.sumType = 40;
          fileName = '库存供应商汇总_';
          break;
        case 'waringSum':
          param = this.$refs["waringSum"].searchParam;
          param.sumType = 50;
          fileName = '库存告警_';
          break;
        case 'minusSum':
          param = this.$refs["minusSum"].searchParam;
          param.sumType = 60;
          fileName = '负库存商品_';
          break;
      }
      const loading = this.$loading({
        lock: true,
        text: '数据导出中，请稍候...',
        background: 'rgba(225, 225, 225, 0.8)',
      });
      this.$axios.PostBlob(url, param).then(res => {
        if (res.status === 200) {
          fileName = fileName + this.$utils.getDateTime() + ".xlsx";
          let blob = new Blob([res.data])
          let downloadElement = document.createElement('a');
          let href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = fileName; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
          this.$notify({
            type: "success",
            title: '导出操作',
            message: '成功!文件名称:' + fileName,
            showClose: false,
          });
          // this.$message.success("导出成功,文件名称:" + fileName);
        } else {
          this.$notify({
            type: "error",
            title: '导出操作',
            message: '失败',
            showClose: false,
          });
          // this.$message.error("导出失败,请稍后再试");
        }
      }).catch((err) => {
        this.$message.warning("当前导出数据为空或超出10000条。");
      }).finally(() => {
        loading.close();
      });
    },
  }
}
</script>

<style scoped>
.page-template {
  padding-top: 0;
}
</style>



// WEBPACK FOOTER //
// src/page/warehouse/QueryInventory.vue